import React from "react";

const UpdateOutlined = ({ color = "#fff", ...props }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.71 2.29L15 0H7V8L9.3 5.7C11.27 7.16 12.55 9.48 12.55 12.12C12.55 13.43 12.23 14.66 11.67 15.75C14 14.23 15.55 11.61 15.55 8.62C15.55 6.1 14.44 3.85 12.71 2.29Z" fill="#424242"/>
    <path d="M3.45996 5.88C3.45996 4.57 3.77996 3.34 4.33996 2.25C1.99996 3.77 0.459961 6.39 0.459961 9.38C0.459961 11.9 1.55996 14.15 3.29996 15.71L0.999961 18H8.99996V10L6.69996 12.3C4.73996 10.84 3.45996 8.52 3.45996 5.88Z" fill="#111827"/>
    </svg>
);
export default UpdateOutlined;